import React, { useState, useCallback, useEffect } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import "./stampingToolCapabilities.css"
import logoStampingToolTool from "../../imagens/logos/logoStampingTool.png"
import { Link } from 'react-router-dom'



function StampingToolToolCapabilities({ listStampingTool }) {
    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)


    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const handleOpenModal = (index) => {
        setOpenModal(true)
        setSlideNumber(index)
    }

    const prevSlide = useCallback(() => {
        slideNumber === 0 ?
            setSlideNumber(listStampingTool.length - 1) :
            setSlideNumber(slideNumber - 1)
    }, [slideNumber, listStampingTool.length])

    const nextSlide = useCallback(() => {
        slideNumber + 1 === listStampingTool.length ?
            setSlideNumber(0) :
            setSlideNumber(slideNumber + 1)
    }, [slideNumber, listStampingTool.length])


    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break;
                case 'ArrowRight':
                    nextSlide()
                    break;
                default:
                    break;
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);

    return (
        <div>

            {
                openModal &&
                <div className='stampingToolSliderWrap'>
                    <FontAwesomeIcon className='stampingToolBtnPrev' icon={faCircleChevronLeft} onClick={prevSlide} />
                    <FontAwesomeIcon className="stampingToolBtnNext" icon={faCircleChevronRight} onClick={nextSlide} />
                    <FontAwesomeIcon className='stampingToolBtnClose' icon={faCircleXmark} onClickCapture={handleCloseModal} />
                    <img className="stampingToolFullScreen" src={listStampingTool[slideNumber].img} alt='imgStampingTool' />
                </div>
            }
            <div>
                <img className='img-custom-size img-fluid ms-2' src={logoStampingToolTool} alt='logoStampingTool' />
            </div>
            <div className="stampingToolGalleryWrap">

                {
                    listStampingTool && listStampingTool.map((image, index) => {
                        return (
                            <div
                                className="stampingToolSingle"
                                key={index}
                                onClick={() => handleOpenModal(index)}
                            >
                                <img src={image.img} alt="stampingTool" />

                            </div>
                        )
                    })
                }
            </div>
            <div className="text-center text-nowrap my-4">
                <Link to="/Capabilities/ToolingAndManufacturing">
                    <button className="stampingToolButton">Back to tollings design and manufacturing</button>
                </Link>
            </div>
        </div>
    )
}


export default StampingToolToolCapabilities